import React, { useState, ChangeEvent } from "react";

interface OutputData {
  message_content: string;
  table_content: string;
}

interface Props {
  inputText: string;
  setInputText: React.Dispatch<React.SetStateAction<string>>;
  outputData: {};
  setOutputData: React.Dispatch<React.SetStateAction<OutputData>>;
}

const BACKEND_URL = "https://thiruvalluvar-backend.fly.dev/";

function MessageBox({
  inputText,
  setInputText,
  outputData,
  setOutputData,
}: Props) {
  const [buttonColor, setButtonColor] = useState("#E5E5E5");

  const handleInputChange = (event: ChangeEvent<HTMLInputElement>) => {
    const text = event.target.value;
    setInputText(text);
    setButtonColor(text.trim() ? "#7ED6CA" : "#E5E5E5");
  };

  const sendQuery = async () => {
    if (!inputText.trim()) return;

    try {
      const response = await fetch(BACKEND_URL, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({ query: inputText }), // ✅ FIX
      });

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }

      const data = await response.json();
      setOutputData(data);
      console.log(data);

      setButtonColor("#E5E5E5");
    } catch (error) {
      console.error("Request failed:", error);
    }
  };

  const handleInputKeyPress = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === "Enter") {
      sendQuery();
    }
  };

  return (
    <div className="center-container">
      <input
        type="text"
        placeholder="Ask Valluvar..."
        value={inputText}
        onChange={handleInputChange}
        onKeyDown={handleInputKeyPress}
      />
      <button
        className="rounded-button"
        style={{ backgroundColor: buttonColor }}
        onClick={sendQuery}
      >
        <span className="button-symbol">&uarr;</span>
      </button>
    </div>
  );
}

export default MessageBox;
